import {POINTER_EVENT_DEFAULT_VALUES} from "../pointer-event-default-values";

export const currentMousePointerId = POINTER_EVENT_DEFAULT_VALUES.pointerId + 1;
